/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Form,
  Header,
  Button,
  Divider,
  Icon,
} from 'semantic-ui-react';
import CurrencySymbol from './CurrencySymbol';
import { isPricingPackageLocked, vnPackageLockMessage } from '../utils/vietnamPricing';
import LoanAmount from './LoanAmount';

export default class EditFeePackageModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool,
    selectedFeePackage: PropTypes.string,
    auth: PropTypes.shape({
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
    }),
    feePackages: PropTypes.arrayOf(PropTypes.shape()),
    isMobile: PropTypes.bool,
    bookingData: PropTypes.shape(),
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      bookingFpItems: [],
      bookingSpaItems: [],
      currentBookingFeePackage: {},
      isCurrentBookingFP: true,
      projectFpItems: [],
      projectSpaItems: [],
      selectedFeePackageItem: {},
      selection: '',
    };
  }

  componentDidMount() {
    const { selectedFeePackage } = this.props;
    if (selectedFeePackage) {
      this.handleSetSelectedFeePackage(selectedFeePackage);
    }
  }

  handleOnResetCalculationItems = (pp, isBooking = false) => {
    const isBookingPP = isBooking && pp && pp.items && pp.items.length > 0;
    const isProjectPP = !isBooking && pp && pp && pp.projectFeePackage && pp.projectFeePackage.formulas && pp.projectFeePackage.formulas.length > 0;
    if (isBookingPP || isProjectPP) {
      const formulas = isBookingPP ? pp.items.filter(bc => bc.isEnabled) : pp.projectFeePackage.formulas;
      this.setState({
        bookingFpItems: isBookingPP ? formulas : [],
        projectFpItems: isBookingPP ? [] : formulas,
      });
    } else {
      this.setState({
        bookingFpItems: [],
        projectFpItems: [],
      });
    }
  }

  handleSelectFeePackage = (e, data) => {
    e.preventDefault();
    this.handleSetSelectedFeePackage(data.value);
    this.setState({ selection: data.value });
  }

  handleSetSelectedFeePackage = (selected) => {
    const { bookingData, feePackages } = this.props;
    if (selected) {
      if (feePackages && feePackages.length > 0) {
        const selectedPP = feePackages.find(pp => pp.projectFeePackageID === selected);
        if (selectedPP) {
          if (bookingData.packageFee && bookingData.packageFee.projectFeePackageID === selected) {
            this.setState({
              isCurrentBookingFP: true,
              currentBookingFeePackage: bookingData.packageFee,
              selectedFeePackageItem: {},
            });
            this.handleOnResetCalculationItems(bookingData.packageFee, true);
          } else {
            this.setState({
              isCurrentBookingFP: false,
              currentBookingFeePackage: {},
              selectedFeePackageItem: selectedPP,
            });
            this.handleOnResetCalculationItems(selectedPP);
          }
        } else if (bookingData && bookingData.packageFeeID) {
          // not in unit package pricing
          this.setState({
            isCurrentBookingFP: true,
            currentBookingFeePackage: bookingData.packageFee,
            selectedFeePackageItem: {},
          });
          this.handleOnResetCalculationItems(bookingData.packageFee, true);
        }
      } else {
        this.setState({
          isCurrentBookingFP: false,
          currentBookingFeePackage: {},
          selectedFeePackageItem: {},
        });
        this.handleOnResetCalculationItems(null);
      }
    }
  }

  handleSubmit = () => {
    const { selectedFeePackageItem } = this.state;
    const { onSubmit, onClose } = this.props;
    if (onSubmit && selectedFeePackageItem) {
      onSubmit(selectedFeePackageItem);
    }
    onClose();
  };

  shapeOptions = (pp, bookingData) => {
    if (pp || bookingData.packageFeeID) {
      const newPP = pp.map((d) => {
        const id = d.projectFeePackage.id;
        const optText = d.projectFeePackage.name;
        const optDescp = d.projectFeePackage.description;

        return ({
          text: optText,
          description: optDescp,
          value: id,
          content: (
            <Header className="ddPricingTierItem">
              <div className="name">{optText}</div>
              <Header.Subheader>{optDescp}</Header.Subheader>
            </Header>
          ),
        });
      });
      if (bookingData.packageFee) {
        const inPP = pp.find(p => p.id === bookingData.packageFeeID);
        if (!inPP) {
          newPP.unshift({
            text: bookingData.packageFee.name,
            description: bookingData.packageFee.description,
            value: bookingData.packageFee.projectFeePackageID,
            content: (
              <Header className="ddPricingTierItem">
                <div className="name">{bookingData.packageFee.name}</div>
                <Header.Subheader>{bookingData.packageFee.description}</Header.Subheader>
              </Header>
            ),
          });
        }
      }
      return newPP;
    }
    return [];
  };

  renderAmountWithCurrency = (amount, currency) => (
    <LoanAmount
      projectCurrencies={currency}
      format="0,000,000.00"
      amount={amount ? amount.toFixed(2) : '0.00'}
      prefix={<CurrencySymbol />}
    />
  );

  renderContent = (i, currency) => {
    const { isCurrentBookingFP } = this.state;
    const items = isCurrentBookingFP ? i : i.filter(c => c.applyToBooking);
    if (items && items.length > 0) {
      return (
        <div style={{ width: '100%' }}>
          <Grid columns={2} className="itemContents">
            {
              items.map(item => (
                <Grid.Row key={item.id} className="itemRow">
                  <Grid.Column textAlign="left" width={9}>
                    <p className="text-item">
                      <span>
                        {item.name}
                      </span>
                    </p>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={7}>
                    <p className="text-item">
                      <span className="text_add">
                        <Icon color="green" size="small" name="plus" />&nbsp;
                        {this.renderAmountWithCurrency(item.valueChange, currency)}
                      </span>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              ))
            }
          </Grid>
        </div>
      );
    }
    return null;
  }

  renderPriceBreakdown = ({
    listPrice,
    spaPrice,
    nettPrice,
    currency,
  }) => {
    const {
      bookingFpItems,
      isCurrentBookingFP,
      projectFpItems,
      currentBookingFeePackage,
      selectedFeePackageItem,
    } = this.state;
    const items = isCurrentBookingFP ? bookingFpItems : projectFpItems;
    const totalPrice = isCurrentBookingFP ? currentBookingFeePackage.totalPrice : selectedFeePackageItem.totalPrice;
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <p className="text-title">List price</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="text-title">
              {this.renderAmountWithCurrency(listPrice, currency)}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <p className="text-title">SPA price</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="text-title">
              {this.renderAmountWithCurrency(spaPrice, currency)}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <p className="text-title">Nett selling price</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="text-title">
              {this.renderAmountWithCurrency(nettPrice, currency)}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Divider />
        {
          items.length > 0 ? (
            <Grid.Row className="packageFormula">
              <Grid.Column width={12}>
                <p className="text-title">Fee formula(s)</p>
              </Grid.Column>
            </Grid.Row>
          ) : (
            <Grid.Row>
              <Grid.Column>
                <p className="text-title">Fee formula(s)</p>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <p className="text-title">
                  N/A
                </p>
              </Grid.Column>
            </Grid.Row>
          )
        }
        {this.renderContent(items, currency)}
        <Divider style={{ width: '100%' }} />
        {
          totalPrice && (
            <Grid.Row className="totalPrice">
              <Grid.Column>
                <p className="text-title">Total additional fees</p>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <p className="text-title">
                  {this.renderAmountWithCurrency(totalPrice, currency)}
                </p>
              </Grid.Column>
            </Grid.Row>
          )
        }
      </Grid>
    );
  }

  render() {
    const {
      bookingData,
      isMobile,
      loading,
      feePackages,
      selectedFeePackage,
    } = this.props;
    const {
      selectedFeePackageItem,
    } = this.state;
    const { selection } = this.state;
    // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.
    const statusID = bookingData && bookingData.statusID;
    if (isPricingPackageLocked(this.props.auth, statusID, 'fee')) {
      return (
        <section className="edit_package_pricing">
          <p className="text-body">
            <Icon name="lock" />
            {this.props.t(vnPackageLockMessage(this.props.auth, statusID, 'fee'))}
          </p>
        </section>
      );
    }
    return (
      <section className="edit_package_pricing">
        <Grid columns={isMobile ? 1 : 2}>
          <Grid.Row>
            <Grid.Column className="ppSelection">
              <p className="text-body">
                If you wish to edit Fee Formulas in the Package, please select the right package, save, exit and choose Customise formula(s)
              </p>
              <p className="text-subtitle">
                Additional fee package&nbsp;
                <span style={{ color: 'red' }}>*</span>
              </p>
              <Form.Select
                className="ddPricingTierDropdown"
                options={this.shapeOptions(feePackages, bookingData)}
                value={selection || selectedFeePackage}
                selection
                fluid
                onChange={this.handleSelectFeePackage}
                noResultsMessage="No additional fee package found."
                placeholder="Select Additional Fee Package"
              />
            </Grid.Column>
            <Grid.Column>
              <div className="packagePricingBreakdown">
                {this.renderPriceBreakdown({
                  listPrice: bookingData.unitSellingPrice,
                  spaPrice: bookingData.spaValue,
                  nettPrice: bookingData.nettSellingPrice,
                  currency: bookingData.project.projectCurrency,
                })}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column textAlign="right">
              <Button
                content="Save Package"
                disabled={!selectedFeePackageItem || !selectedFeePackageItem.id}
                loading={loading}
                className="submit-button text-title"
                onClick={this.handleSubmit}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditFeePackageModal.jsx